async function loadScript(src) {
	return new Promise((resolve, reject) => {
		let script = document.createElement("script");
		script.onload = () => resolve();
		script.onerror = reject;
		script.src = src;
		document.body.appendChild(script);
	});
}
async function aPrompt(data, value, customSelector, validatorFunc) {
	let settings = {};

	// обратная совместимость
	// если появились новые параметры то передаем их через объект
	if (typeof data === 'object') {
		settings = data;
	} else {
		settings.text = data;
		settings.value = value;
		settings.customSelector = customSelector;
		settings.validatorFunc = validatorFunc;
	}

	var $input;
	var $dialog;
	if (typeof settings.customSelector === "undefined") {
		$dialog = aCreateDialog();
		$dialog.addClass("aPrompt");
		$(".modal-pure__infopart", $dialog).html(settings.text);
		$input = $("<input class='input' type='text'>");
		$(".modal-pure__input", $dialog).append($input);
		var $ok = $("<button class='blue-button ok'>OK</button>");
		var $cancel = $("<button class='grey-button cancel'>Отмена</button>");
		$(".modal-pure__buttons", $dialog).html('').append($ok).append($cancel);
	} else {
		$dialog = aCreateDialog(settings.customSelector);
		$input = $(".input", $dialog);
		if (typeof window['set_numeric'] === "function") {
			window['set_numeric']($dialog);
		}

	}
	$dialog.$input = $input;
	if (typeof settings.value !== "undefined") {
		$input.val(settings.value);
	}

	$input.on("keypress", function (e) {
		if (e.keyCode === 13) {
			$(".ok", $dialog).trigger("click");
		}
	});

	if (settings.inputmask) {
		$input.attr('inputmask', settings.inputmask);
		$input.inputmask({mask: [$input.attr("inputmask")]});
	}

	$dialog.showDialog();
	if ($input.length > 0) {
		$input.focus().select();
	} else {
		$("button.ok", $dialog).focus();
	}

	return $dialog.promises(settings.validatorFunc);
}
async function aConfirm(text, okTitle, cancelTitle, noclose, className) {
	if (typeof okTitle === "undefined") {
		okTitle = "ОК";
	}
	if (typeof cancelTitle === "undefined") {
		cancelTitle = "Отмена";
	}
	var $dialog = aCreateDialog(undefined, className, noclose);
	$dialog.addClass("aConfirm");
	$(".modal-pure__infopart", $dialog).html(text);

	$(".modal-pure__buttons", $dialog).html('');

	if (okTitle !== null) {
		var $ok = $("<button class='blue-button ok'>" + okTitle + "</button>");
		$(".modal-pure__buttons", $dialog).append($ok);
	}

	if (cancelTitle !== null) {
		var $cancel = $("<button class='grey-button cancel'>" + cancelTitle + "</button>");
		$(".modal-pure__buttons", $dialog).append($cancel);
	}

	$dialog.showDialog();
	setTimeout(() => $ok.focus(), 1);

	return $dialog.promises();
}

function aConfirmSubmit(form, text) {
	if (!text) {
		text = "Отправить данные?";
	}
	aConfirm(text).then((res)=> {
		if (res) {
			form.submit();
		}	
	});
	return false;
}

async function aAlert(text, className) {
	var $dialog = aCreateDialog(undefined, className);
	$dialog.addClass("aAlert");
	$(".modal-pure__infopart", $dialog).html(text);

	var $ok = $("<button class='blue-button ok'>ОК</button>");
	$(".modal-pure__buttons", $dialog).html('').append($ok);
	console.trace("aAlert");
	$dialog.showDialog();
	setTimeout(() => $ok.focus(), 1);

	return $dialog.promises();
}

function aDialog(selector, className, noclose) {
	var $dialog = aCreateDialog(selector, className, noclose);
	$dialog.showDialog();
	return $dialog.promises();
}

function aCreateDialog(selector, className, noclose) {
	var $dialog;
	var $selected = $(selector);
	if ($selected.length === 0) {
		var isNew = true;
		if (!className) {
			className = "";
		}
		$dialog = $(`	<div class="aDialog-custom modal-pure ${className}">
		<div class="modal-pure__box">
			<div class="dialog-title"></div>
			<div class="modal-pure__infopart"></div>
			<div class="modal-pure__input"></div>
			<div class="modal-pure__buttons"></div>
			<div class="modal-pure__close"></div>
		</div>
	</div>`);
	} else {
		$dialog = $selected.clone();
		$dialog.addClass(className);
		if (typeof window['set_numeric'] === "function") {
			window['set_numeric']($dialog);
		}
	}

	$dialog.data('aDialog', $dialog);


	var escape = () => {
	};

	if (noclose) {
		$dialog.find(".modal-pure__close").remove();
	} else {
		escape = function (e) {
			if (e.keyCode === 27) {
				e.preventDefault();
				$dialog[0].dispatchEvent(new Event("escape"));
				$dialog.closeDialog();
				return false;
			}
		};
	}

	$dialog.appendTo("body");
	$dialog.showDialog = function () {
		$dialog.css("display", "flex");
		setTimeout(function () {
			$dialog.addClass("active");
		}, 1);
		document.addEventListener('keydown', escape);
	};
	$dialog.closeDialog = function () {
		console.log("CLOSE", $dialog);
		$dialog.removeClass("active");
		var duration = parseFloat($dialog.css("transition-duration")) * 1000;
		if (!duration || isNaN(duration)) {
			duration = 300;
		}
		document.removeEventListener('keydown', escape);
		setTimeout(function () {
			$dialog.remove();
		}, duration);
	};
	$dialog.promises = function (validatorFunc) {
		return new Promise(function (resolve, reject) {

			$dialog.on("click", function (e) {
				//e.preventDefault();
				e.stopPropagation();
				if (e.target === $(".cancel", $dialog)[0] || (!noclose && (e.target === this || e.target === $dialog.find(".modal-pure__close")[0]))) {
					$dialog.closeDialog();
					resolve(false);
				}
			});

			$(".ok", $dialog).on("click", async function (event) {
				event.preventDefault();
				event.stopPropagation();
				var resolveVal;
				if (event?.target?.dataset?.value !== void 0) {
					resolveVal = event?.target?.dataset?.value;
				} else if (typeof $dialog.$input === "undefined") {
					//нет инпута, резолвим true
					resolveVal = true;
				} else {
					//есть инпут, резолвим его val
					resolveVal = $dialog.$input.val();

					if (validatorFunc) {
						//есть функция валидатора
						var validateResultRaw = validatorFunc(resolveVal);
						//console.log(validateResultRaw);
						var validateResult;
						if (typeof validateResultRaw === "object") {
							validateResult = await validateResultRaw;
						} else {
							validateResult = validateResultRaw;
						}
						if (!validateResult) {
							//некорректное значение
							$dialog.$input.focus();
							return false;
						}
					}
				}
				$dialog.closeDialog();
				resolve(resolveVal);
			});
			$dialog.on("escape", function (event) {
				event.preventDefault();
				event.stopPropagation();
				$dialog.closeDialog();
				resolve(false);
			});
		});
	};

	return $dialog;
}

async function aCheckResult(func) {
	var response = null;
	try {
		response = await func;
	} catch (e) {
		console.log(e.responseText);
		return {"success": false};
	}
	if (response !== null && typeof response === "object") {
		if (response.code === 200) {

		} else if (response.code === 401) {
			await aAlert("Вы не авторизированы страница будет перезагружена");
			window.location.reload();
		} else {
			if (response.message) {
				await aAlert("Ошибка: " + response.message);
			} else {
				await aAlert("Ошибка: " + response.code);
			}
		}
	}
	return response;
}

async function aGetData(url) {
//	return new Promise(function (resolve, reject) {
//		jQuery.ajax({
//			type: "GET",
//			url: url,
//			success: function (result) {
//				resolve(result);
//			},
//			error: function (result) {
//				reject(result);
//			}
//		});
//	});
	return await aCheckResult(jQuery.ajax({
		url: url,
		type: 'GET',
		success: function (result) {
			//resolve(result);
		},
		error: function () {
			//reject();
		}
	}));
}

async function aPostData(url, formData) {
	return await aCheckResult(jQuery.ajax({
		url: url,
		type: 'POST',
		data: formData,
		contentType: false,
		processData: false,
		//dataType: 'json',
		success: function (result) {
			//console.log("SUCCESS");
		},
		error: function (err) {
			//console.log("ERROR", err);
		}
	}));
}

async function aModalForm(formUrl, submitUrl) {
	var formHtml = "";
	var response = await aGetData(formUrl);
	if (typeof response === "object") {
		//no testing
		if (response.code === 200) {
			if (typeof response.html !== "undefined") {
				formHtml = response.html;
			} else if (response.data) {
				formHtml = response.data[0];
			}
		} else {
			return false;
		}
	} else if (typeof response === "string") {
		formHtml = response;
	}
	var $dialog = aCreateDialog();
	$(".modal-pure__infopart", $dialog).html(formHtml);

	var $ok = $("<button class='blue-button'>ОК</button>");
	$(".modal-pure__buttons", $dialog).html('').append($ok);
	$dialog.showDialog();
	$ok.focus();

	return new Promise(function (resolve, reject) {
		$dialog.on("click", function (e) {
			if (e.target === this || e.target === $dialog.find(".modal-pure__close")[0]) {
				e.preventDefault();
				e.stopPropagation();
				$dialog.closeDialog();
				resolve(false);
			}
		});

		$ok.on("click", async function (event) {
			$ok.prop("disabled", true);
			event.preventDefault();
			event.stopPropagation();
			var form = $("form", $dialog)[0];
			for (var i = 0; i < form.elements.length; i++) {
				if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
					await aAlert("Заполните все обязательные поля");
					form.elements[i].focus();
					$ok.prop("disabled", false);
					return false;
				}
			}
			var fd = new FormData(form);
			var result = await aPostData(submitUrl, fd);
			if (typeof result.success !== "undefined" && result.success === false && typeof result.message !== "undefined") {
				//await aAlert("Ошибка: " + result.message);
				$ok.prop("disabled", false);
				return false;
			}
			$ok.prop("disabled", false);
			$dialog.closeDialog();
			resolve(result);
		});
		$dialog.on("escape", function (event) {
			event.preventDefault();
			event.stopPropagation();
			$dialog.closeDialog();
			resolve(false);
		});
	});
}
async function aModalDialog(options) {
	var defaults = {
		closeOnShadowClick: true,
		title: "",
		html: "",
		dialogClass: "",
		onCancel: function (event, $dialog, resolve) {
			event.preventDefault();
			event.stopPropagation();
			$dialog.closeDialog();
			resolve(false);
		},
		onSuccess: async function (event, $dialog, resolve) {
			$dialog.ok.prop("disabled", true);
			event.preventDefault();
			event.stopPropagation();
			$dialog.ok.prop("disabled", false);
			$dialog.closeDialog();
			resolve(true);
		},
		onShow: function () {},
		buttons: {
			ok: {
				disable: true,
				enable: true,
				title: "Ok",
				description: "",
				btnClass: "blue-button",
				onClick: function (event) {

				}
			},
			cancel: {
				enable: true,
				title: "Закрыть",
				description: "",
				btnClass: "red-button",
				onClick: function (event) {

				}
			}
		}
	};
	jQuery.extend(true, defaults, options);
	var $dialog = aCreateDialog(undefined, defaults.dialogClass);
	jQuery(".dialog-title", $dialog).html(defaults.title);
	jQuery(".modal-pure__infopart", $dialog).html(defaults.html);

	const buttonDescription = $('<p>', {class: "button__description"});

	var $ok = jQuery("<button class=" + defaults.buttons.ok.btnClass + ">" + defaults.buttons.ok.title + "</button>");

	var $cancel = jQuery("<button class=" + defaults.buttons.cancel.btnClass + ">" + defaults.buttons.cancel.title + "</button>");

	if (defaults.buttons.ok.enable) {
		jQuery(".modal-pure__buttons", $dialog).append($ok);

		if (defaults.buttons.ok.description) {
			let description = buttonDescription.append(defaults.buttons.ok.description);
			jQuery(".modal-pure__buttons", $dialog).append(description);
		}

		$dialog.ok = $ok;
	}
	if (defaults.buttons.cancel.enable) {
		jQuery(".modal-pure__buttons", $dialog).append($cancel);

		if (defaults.buttons.cancel.description) {
			let description = buttonDescription.append(defaults.buttons.ok.cancel);
			jQuery(".modal-pure__buttons", $dialog).append(description);
		}
		$dialog.cancel = $cancel;
	}
	$dialog.showDialog();
	if (typeof defaults.onShow === "function") {
		defaults.onShow();
	}
	if (defaults.buttons.ok.enable) {
		$ok.focus();
	}

	return new Promise(function (resolve, reject) {
		$dialog.on("click", function (event) {
			if ((event.target === this && defaults.closeOnShadowClick) || event.target === $dialog.find(".modal-pure__close")[0]) {
				defaults.onCancel(event, $dialog, resolve);
			}
		});
		$ok.on("click", async function (event) {
			if (typeof defaults.buttons.ok.onClick === "function") {
				defaults.buttons.ok.onClick(event);
			}
			defaults.onSuccess(event, $dialog, resolve);
		});
		$cancel.on("click", function (event) {
			if (typeof defaults.buttons.cancel.onClick === "function") {
				defaults.buttons.cancel.onClick(event);
			}
			defaults.onCancel(event, $dialog, resolve);
		});
		$dialog.on("escape", function (event) {
			defaults.onCancel(event, $dialog, resolve);
		});
	});
}

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Откладывает выполнение пока не завершится действие
 * https://doka.guide/js/debounce/#pishem-debounce
 * @param callee
 * @param timeoutMs
 */
function debounce(callee, timeoutMs) {
	return function perform(...args) {
		let previousCall = this.lastCall;

		this.lastCall = Date.now();

		if (previousCall && this.lastCall - previousCall <= timeoutMs) {
			clearTimeout(this.lastCallTimer);
		}

		this.lastCallTimer = setTimeout(() => callee(...args), timeoutMs);
	};
}

/**
 * Создаёт обёртку функции, ограничивающую частоту её вызова — она будет выполняться
 * не чаще одного раза за указанный интервал времени. Все промежуточные вызовы
 * в течение этого интервала игнорируются.
 * Полезно для оптимизации обработчиков событий, таких как `scroll`, `resize` и др.
 * https://doka.guide/js/throttle/#pishem-throttle
 * 
 * @param {Function} func - Функция, вызовы которой необходимо ограничить.
 * @param {number} timeout - Минимальный интервал между вызовами в миллисекундах.
 * @returns {Function} Обёрнутая функция, которая при вызове применяет throttling к `func`.
 */
function throttle(func, timeout) {
	let timer = null;
	return function perform(...args) {
		if (timer)
			return;

		timer = setTimeout(() => {
			func(...args);
			clearTimeout(timer);
			timer = null;
		}, timeout);
	};
}

/**
 * Модальное с подтверждением перед переходом по ссылке
 * Используется только onclick для a тегов
 * @param {type} event - событие для сброса
 * @param {type} text - текст confirm
 * @returns {undefined}
 * @example <a href="?comp_id=$comp_id&reset=$row.get('id')" onclick="confirmBeforeRedirect(event, 'Сбросить?'); return false;">Сброс</a>
 */
async function confirmBeforeRedirect(event, text) {
	event.preventDefault();

	const shouldRedirect = await aConfirm(text);

	if (shouldRedirect) {
		window.location.href = event.target.href;
	}
}
/**
 * Модальное с подтверждением перед публикацией по ссылке
 * requestSubmit нормально инициализирует отправку формы, в отличие от submit
 * используется then вместо async, чтобы не ломать fallback
 * Используется только для onclick submit кнопки
 * Можно сделать несколько подтверждений подряд, если передать массив с текстами
 * @param {type} event - событие для сброса
 * @param {type} text - текст confirm 
 * @returns {undefined}
 */
function confirmBeforeSubmit(event, text) {
	const el = event.target;
	const form = el.closest('form');

	if (!text) {
		console.error("Введите текст\n" + text);
		return;
	}

	// Обработка несколько подтверждений подряд
	// Преобразуем текст в массив для единообразной обработки
	const confirmTexts = Array.isArray(text) ? text : [text];

	if (form.requestSubmit) {
		event.preventDefault();

		function processConfirms(texts, index = 0) {
			if (index >= texts.length) { // завершение рекурсии 
				form.requestSubmit(el);
				return;
			}

			aConfirm(texts[index]).then((shouldSubmit) => {
				if (shouldSubmit) {
					// Переходим к следующему подтверждению
					processConfirms(texts, index + 1);
				}
				// Если пользователь отказался, просто не продолжаем
			});
		}
		processConfirms(confirmTexts);
	} else {
		// fallback для requestSubmit
		// используем обычный confirm чтобы не ломать дальнейшие проверки
		for (let i = 0; i < confirmTexts.length; i++) {
			if (!confirm(confirmTexts[i])) {
				return false;
			}
		}
		return true;
	}
}

/**
 * Проверка значения инпута перед отправкой формы
 * @param {type} arguments[0] - объект с параметрами
 * @returns {undefined|Boolean}
 */
async function checkInpVal( {
inputName: inputName,
	validateFunc: validateFunc, // функция проверки (validateOgrn, validateKPP, validateSnils и т.д.) или сразу результат проверки (как boolean)
	error = {}, // по умолчанию объект
	shouldKeep = false // можно ли продолжить, если не прошел проверку (для aConfirm)
	} = {}) {

	try {
		const inp = $('[name="' + inputName + '"]');
		if (!inp.length) {
			console.error("Ошибка");
			return;
		}

		if (typeof error === 'string') { // если строка то просто выводим ошибку
			let isValidated = false;
			if (typeof validateFunc === 'boolean') {
				isValidated = validateFunc; // если буль, то результат напрямую присваиваем
			} else if (typeof validateFunc === 'function') {
				isValidated = validateFunc(inp.val());
			} else {
				console.error("Не тот тип данных validateFunc");
			}

			if (!isValidated) { // если не проходим проверку
				if (shouldKeep) { // если можно продолжить то у нас aConfirm
					const res = await aConfirm(error);
					if (!res) {
						return false;
					}
				} else {
					await aAlert(error);
					inp.focus();
					return false;
				}
			}
		} else { // по умолчанию error объект и выводим error.message
			const isValidated = validateFunc(inp.val(), error);
			if (!isValidated) {
				if (shouldKeep) {
					const res = await aConfirm(error.message);
					if (!res) {
						return false;
					}
				} else {
					await aAlert(error.message);
					inp.focus();
					return false;
				}
			}
		}
		return true;
	} catch (e) {
		aAlert("Что-то пошло не так. Обратитесь к оператору поддержки");
		return false;
}
}

/**
 * Проверка ФИО перед отправкой формы
 * @param {type} inpName
 * @returns {Boolean}
 */
async function checkFIO(inpName) {
	const inp = $("[name=" + inpName + "]");
	let noValueWarning = null;
	let failedValidate = null;

	switch (inpName) {
		case "famil":
		{
			noValueWarning = "Укажите фамилию.";
			failedValidate = "Недопустимые символы в фамилии. ";
			break;
		}
		case "imya":
		{
			noValueWarning = "Укажите имя.";
			failedValidate = "Недопустимые символы в имени. ";
			break;
		}
		case "otch":
		{
			noValueWarning = null;
			failedValidate = "Недопустимые символы в отчестве. ";
			break;
		}
	}

	if (inp.length > 0) {
		inp.val(inp.val().trim())
		const val = inp.val();

		if (!noValueWarning) {
			return true;
		}

		if (!val) {
			await aAlert(noValueWarning);
			return false;
		}

		const res = validateFIO(val);
		if (!res) {
			await aAlert(failedValidate);
			inp.focus();
			return false;
		}
	}
	return true;
}